import React from "react";
import { Col, Row } from "react-bootstrap";

const AboutChild_Certificates = (props) => {
  return (
    <>
      <h2 className="m-0 pb-3">My Certificates</h2>
      <hr />
      <Row className="py-3">
        <Col md={5} xs={5}>
          <h6 className="title-primary">2015</h6>
        </Col>
        <Col md={7} xs={7}>
          <h5 className="title-primary">PHP</h5>
          <span>TOPS Technologies</span>
        </Col>
      </Row>
      <hr />
      {/* <Row className="py-3">
        <Col md={5} xs={5}>
          <h6 className="title-primary">2009</h6>
        </Col>
        <Col md={7} xs={7}>
          <h5 className="title-primary">Tally 9</h5>
          <span>Soni Academy Computer Training & Computer Education</span>
        </Col>
      </Row>
      <hr />
      <Row className="py-3">
        <Col md={5} xs={5}>
          <h6 className="title-primary">2007</h6>
        </Col>
        <Col md={7} xs={7}>
          <h5 className="title-primary">DCA</h5>
          <span>Shree Sahjanand Computer Center</span>
        </Col>
      </Row>
      <hr /> */}
    </>
  );
};

export default AboutChild_Certificates;
